import React, { useContext } from "react";

export const WizardContext = React.createContext(null);

export function useWizard() {
  return useContext(WizardContext);
}

export function WizardProvider({ children, value }) {
  return (
    <WizardContext.Provider value={value}>
      {children}
    </WizardContext.Provider>
  );
}
